var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGovernmentSolid = function SvgGovernmentSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.25a.75.75 0 0 0-.75.75v.077c0 .941 0 2.043.289 2.91.155.467.411.925.844 1.261.44.342.987.502 1.617.502h.25V21c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75V8.75H19c.63 0 1.177-.16 1.617-.502.433-.336.689-.794.845-1.26.288-.868.288-1.97.288-2.911V4a.75.75 0 0 0-.75-.75H3ZM17.25 8a.75.75 0 0 0-.75-.75h-9a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 .75-.75Zm-2.5 12.25h-1.5V16a.75.75 0 0 1 1.5 0v4.25Zm-4 0V16a.75.75 0 0 0-1.5 0v4.25h1.5Zm-4-8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgGovernmentSolid;